package amazon.lastmile.inject

import app.nestbridge.feature.invitations.ui.InvitationListUiFactory
import com.slack.circuit.runtime.ui.Ui
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = InvitationListUiFactory::class)
public interface AppNestbridgeFeatureInvitationsUiInvitationListUiFactory {
  @Provides
  @IntoSet
  public fun provideInvitationListUiFactoryFactoryMultibinding(invitationListUiFactory: InvitationListUiFactory): Ui.Factory = invitationListUiFactory
}
